import { AloAddress, getDefaultAloAddress } from './AloAddress';
import { AloBase, getDefaultAloBase } from './AloBase'
import { AloInscription, cleanAloInscription } from './AloInscription';
import { AloMedia, getDefaultAloMedia } from './AloMedia';
import { AloPageContent, getDefaultAloPageContent } from './AloPageContent';
import { AloTemplateCours, getDefaultAloTemplateCours } from './AloTemplateCours';
import { AloTemplateHoraire, getDefaultAloTemplateHoraire } from './AloTemplateHoraire';


export interface AloCours extends AloBase {          
    acyId:number    
    acyIdCplt:number|null
    psnId:number|null
    usrId:number    
    crsDureeMin:number
    crsCapaciteMax:number
    crsDatdebut:string
    professeur:string
    piscine:string
    inscriptions:Array<AloInscription>

}

export const getDefaultAloCours = (cours:AloTemplateCours = getDefaultAloTemplateCours(),horaire:AloTemplateHoraire = getDefaultAloTemplateHoraire()):AloCours => {
    return {  
        ...getDefaultAloBase(),        
        acyId:cours.acyId,
        acyIdCplt:horaire.acyIdCplt,
        psnId:cours.psnId,
        usrId:horaire.usrId,
        crsDureeMin:cours.tcsDureeMin,
        crsCapaciteMax:cours.tcsCapaciteMax,
        crsDatdebut:'',
        professeur:'',
        piscine:'',
        inscriptions:[]
    }
}

export const cleanAloCours = (cours:AloCours) => {
    if(!cours) return    
    if(!cours.id) delete cours.id
    if(!cours.usrId) delete cours.usrId
    if(!cours.psnId) delete cours.psnId
    if(!cours.acyId) delete cours.acyId
    if(!cours.acyIdCplt) delete cours.acyIdCplt
    cours.inscriptions.forEach(i => cleanAloInscription(i))
    
}